import React from "react";
import WorkInProgress from "./WorkInProgress";

const DeliverablesComponent = () => {
    return (
        <div>
            <WorkInProgress />
            
        </div>
    );
}
export default DeliverablesComponent;